import React from 'react';
import { testimonials, testimonialsSection } from '../../content/siteContent';
import SectionHead from './SectionHead';

export default function Testimonials() {
  return (
    <section id="depoimentos" className="section-wrap">
      <span id="testimonials" className="anchor-alias" aria-hidden="true" />

      <SectionHead tag={testimonialsSection.tag} title={testimonialsSection.title} subtitle={testimonialsSection.subtitle} />

      <div className="testimonials-grid">
        {testimonials.map((item) => (
          <div className="testimonial-card" key={item.name}>
            <p className="testimonial-quote">&quot;{item.quote}&quot;</p>
            <div className="testimonial-author">
              <div className="author-avatar">{item.initials}</div>
              <div>
                <h4 className="author-name">{item.name}</h4>
                <p className="author-role">{item.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
